import { useInView } from "react-intersection-observer";

const UseInViewOnce = () =>
  useInView({
    triggerOnce: true,
    threshold: "0",
  });

export default UseInViewOnce;
